module.exports = __webpack_public_path__ + "media/images/guarantee-11a2423fe8ffaac6fa63662e52ecbfef.png";